/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import '@fortawesome/fontawesome-free/js/all.js';
import Router from './util/Router';
import common from './routes/common';

import Vue from 'vue';
import vSelect from 'vue-select'

window.Vue = require('vue');

Vue.component('category-search', require('./components/CategorySearchComponent.vue').default);
Vue.component('v-select', vSelect);
const routes = new Router({
  common,
});

$(document).ready(() => {
  // console.log('Hello world');
});

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents());

const app = new Vue({
  el: '#app',
});
